import React, { KeyboardEvent, MouseEvent } from 'react';
import type { PMCConfig } from '@kyruus/types';

import type {
  SearchSummary,
  SearchModification,
  SearchFacetWithAppliedTerms,
  Log
} from 'Src/types';
import { FilterChipPopover } from '../../styles';
import { Content } from './Content';

interface FilterPopoverProps {
  config: PMCConfig;
  facet: SearchFacetWithAppliedTerms;
  updateSearch: (modifications: SearchModification[]) => void;
  log: Log;
  onClose: (
    event: KeyboardEvent | MouseEvent,
    reason: 'escapeKeyDown' | 'backdropClick' | 'closeButton'
  ) => void;
  open: boolean;
  searchSummary: SearchSummary;
  targetEl: React.RefObject<HTMLDivElement>;
}

export const FilterPopover = ({
  config,
  facet,
  updateSearch,
  log,
  onClose,
  open,
  searchSummary,
  targetEl
}: FilterPopoverProps) => {
  return (
    <FilterChipPopover
      anchorEl={targetEl.current}
      data-testid={`${facet.field}-popover`}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      role="dialog"
      aria-labelledby={`filter-popover-title-${facet.field}`}
    >
      <Content
        searchSummary={searchSummary}
        customerConfig={config}
        facet={facet}
        updateSearch={updateSearch}
        log={log}
        handleClose={onClose}
      />
    </FilterChipPopover>
  );
};
